import Icon from '@/components/shared/icons'
import UsersEntity from '@/entities/api/users/users'
import DateConvert from '@/utils/date-convert'
import { roleConvert } from '@/utils/role-convert'
import { Badge, Box, Flex, Heading, Image, Text } from '@chakra-ui/react'
import { API_URL } from '@/services/api/keys'
import { AppDispatch } from '@/store/store'
import { useDispatch } from 'react-redux'
import { ToastConfirm } from '../elements/toast-confirm'
import { removeUserById } from '@/services/api/users/users'
import Toast from '../elements/toast'
import { sessionRefrestUpdate } from '@/store/features/state'
import { deleteUserFn } from '@/store/features/users'

const UserCard = ({
	click,
	user,
	token,
}: {
	click: () => void
	user: UsersEntity
	token: string
}) => {
	const dispatch = useDispatch<AppDispatch>()

	const removeUserFn = async (user: UsersEntity) => {
		try {
			ToastConfirm({
				message: '¿Quieres eliminar este elemento?',
				onConfirm: async () => {
					const response = await removeUserById(token, user?._id ?? '')

					if (response?.status === 500 || response?.status === 404) {
						Toast({
							type: 'error',
							message: 'No se pudo eliminar el usuario',
						})
						return
					}

					if (response?.status === 401) {
						Toast({
							type: 'info',
							message: 'La session del usuario a expirado',
						})
						dispatch(sessionRefrestUpdate())
						return
					}

					dispatch(deleteUserFn(user._id ?? ''))
					Toast({
						type: 'success',
						message: 'Se elimino correctamente el usuario',
					})
				},
				onCancel: () => {
					Toast({
						type: 'info',
						message: 'Se cancelo la operacion',
					})
				},
				confirmLabel: 'Eliminar',
				cancelLabel: 'Cancelar',
			})
		} catch (error) {
			Toast({ type: 'error', message: 'No se pudo eliminar el usuario' })
		}
	}

	return (
		<Box
			bg='white'
			borderRadius='md'
			p='3'
			shadow='sm'
			maxW='xs'
			cursor='pointer'
		>
			<Flex flexDirection='column' alignItems='center'>
				<Box w='full' display='flex' justifyContent='space-between' mb={3}>
					<Text fontSize='xs' fontWeight='200' color='gray.500'>
						{DateConvert(user._created ?? 'Sin fecha')}
					</Text>
					<Icon icon='delete' size='sm' click={() => removeUserFn(user)} />
				</Box>

				<Box onClick={click}>
					<Box
						position='relative'
						w='100px'
						h='100px'
						borderRadius='full'
						overflow='hidden'
						shadow='md'
						mx='auto'
						border='3px solid'
						borderColor='gray.200'
					>
						<Image
							src={`${API_URL}/${user.image?.url}`}
							alt='User avatar'
							w='full'
							h='full'
							objectFit='cover'
						/>
					</Box>

					<Text
						textAlign='center'
						whiteSpace='normal'
						fontSize='xs'
						fontWeight='200'
						color='gray.500'
						mt={2}
					>
						{`# ${user._id}`}
					</Text>
					<Heading
						as='h3'
						fontSize='md'
						fontWeight='700'
						color='black'
						textAlign='center'
						wordBreak='break-word'
						whiteSpace='normal'
					>
						{`${user.name} ${user.lastname}`}
					</Heading>

					<Badge
						bg='gray.50'
						color='black'
						p={1.5}
						borderRadius='full'
						fontSize='xs'
						display='flex'
						alignItems='center'
						justifyContent='center'
					>
						<Icon icon='shield' size='lg' color='gray.600' />
						{roleConvert(user.position)}
					</Badge>
				</Box>
			</Flex>
		</Box>
	)
}

export default UserCard
